import React, { useState } from 'react';
import { Phone, Clock, MapPin, CreditCard, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ReviewModal } from '@/components/ReviewModal';

export const Footer = () => {
  const [showReviewModal, setShowReviewModal] = useState(false);
  
  return (
    <>
    <footer data-testid="app-footer" className="bg-slate-900 text-white py-12 sm:py-16 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto max-w-7xl">
        {/* Google Maps Section */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold mb-6 text-center font-['Outfit'] text-rose-400">
            Visit Us
          </h3>
          <div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-rose-600/30">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.8926547812894!2d88.35226347515!3d22.471926179529476!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0270f99c1c5021%3A0xeb9e870abe6f9140!2sUsha%20Kiran%20Medicos!5e0!3m2!1sen!2sin!4v1709876543210!5m2!1sen!2sin"
              width="100%"
              height="350"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Usha Kiran Medicos Location"
              className="w-full"
            ></iframe>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-12 mb-10">
          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6 font-['Outfit'] text-rose-400">USHAKIRAN MEDICOS</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-rose-400 mt-1 flex-shrink-0" />
                <div>
                  <p data-testid="footer-phone-landline" className="font-medium">
                    033-24314431
                  </p>
                  <p data-testid="footer-phone-mobile" className="font-medium">
                    9007667528
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-rose-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-slate-300 leading-relaxed">
                    USHAKIRAN MEDICOS<br />
                    Kolkata, West Bengal
                  </p>
                  <a
                    href="https://www.google.com/maps/place/Usha+Kiran+Medicos/@22.471931,88.3522635,17z/data=!3m1!4b1!4m6!3m5!1s0x3a0270f99c1c5021:0xeb9e870abe6f9140!8m2!3d22.4719261!4d88.3548384!16s%2Fg%2F11b_03ptpv"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-rose-400 hover:text-rose-300 text-sm mt-2 inline-block transition-colors duration-200"
                  >
                    Get Directions →
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Timings */}
          <div>
            <h3 className="text-xl font-bold mb-6 font-['Outfit']">Operating Hours</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-rose-400 mt-1 flex-shrink-0" />
                <div>
                  <p data-testid="footer-timings-weekday" className="font-medium text-rose-400">
                    Monday - Saturday
                  </p>
                  <p className="text-slate-300">7:30 AM - 8:30 PM</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-rose-400 mt-1 flex-shrink-0" />
                <div>
                  <p data-testid="footer-timings-sunday" className="font-medium text-rose-400">
                    Sunday
                  </p>
                  <p className="text-slate-300">7:30 AM - 2:30 PM</p>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Banner */}
          <div>
            <h3 className="text-xl font-bold mb-6 font-['Outfit']">Payment Options</h3>
            <div
              data-testid="footer-payment-banner"
              className="bg-gradient-to-br from-rose-900 to-pink-900 rounded-2xl p-6 border border-rose-700/50"
            >
              <div className="flex items-start gap-3 mb-4">
                <CreditCard className="w-6 h-6 text-rose-400 flex-shrink-0" />
                <p className="text-sm text-slate-200 leading-relaxed">
                  We accept all types of CARD Payment, Online Payment and PAYTM
                </p>
              </div>
              <div className="bg-rose-500/20 rounded-lg px-4 py-3 border border-rose-500/30">
                <p className="text-sm font-semibold text-rose-300 text-center">
                  Even in HOME COLLECTION
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Review Button Section */}
        <div className="border-t border-slate-700 pt-8 pb-6">
          <div className="text-center">
            <Button
              onClick={() => setShowReviewModal(true)}
              className="bg-gradient-to-r from-rose-600 to-pink-600 text-white hover:from-rose-700 hover:to-pink-700 px-8 py-6 text-base font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <Star className="w-5 h-5 mr-2 fill-white" />
              Write a Review
            </Button>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-slate-400">
            <p>
              © {new Date().getFullYear()} USHAKIRAN MEDICOS. All rights reserved.
            </p>
            <p>
              Estd. 2009 | Trusted Healthcare Partner
            </p>
          </div>
        </div>
      </div>
      
      <ReviewModal isOpen={showReviewModal} onClose={() => setShowReviewModal(false)} />
    </footer>
    </>
  );
};